(function ($) {
  'use strict';

  function initializePriceSlider() {
    var slider = $('#slider-range');
    if (!slider.length || !$.fn.slider) return;

    var urlParameters = new URLSearchParams(window.location.search);
    var maximumPrice = Number(urlParameters.get('filter.v.price.lte')) || 500;
    var minimumPrice = Number(urlParameters.get('filter.v.price.gte')) || 1;

    $('#minamount').val(minimumPrice);
    $('#maxamount').val(maximumPrice);

    if (slider.hasClass('ui-slider')) slider.slider('destroy');

    slider.slider({
      range: true,
      min: 1,
      max: 500,
      values: [minimumPrice, maximumPrice],
      slide: function (_event, ui) {
        $('#amount').val('$' + ui.values[0] + ' - $' + ui.values[1]);
        $('#minamount').val(ui.values[0]);
        $('#maxamount').val(ui.values[1]);
      }
    });

    $('#amount').val('$' + slider.slider('values', 0) + ' - $' + slider.slider('values', 1));

    slider.off('slidestop.chicsew').on('slidestop.chicsew', function (event) {
      event.preventDefault();
      var nextParameters = new URLSearchParams(window.location.search);
      nextParameters.set('filter.v.price.gte', $('#minamount').val());
      nextParameters.set('filter.v.price.lte', $('#maxamount').val());
      window.location.assign(window.location.href.split('?')[0] + '?' + nextParameters.toString());
    });
  }

  document.addEventListener('DOMContentLoaded', initializePriceSlider);
  document.addEventListener('reload-collection', initializePriceSlider);
})(window.jQuery);

/* Mobile quick filters share one in-flow panel area below a scrollable chip row.
 * Keep the original inputs inside their widgets so the theme's AJAX filtering
 * and the separate Filter By drawer continue using the same event handlers. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 991px)');
  var nextPanelId = 0;

  function initializeQuickFilters() {
    document.querySelectorAll('.template-collection .toolbar.aa .col-sidebar').forEach(function (root) {
      if (root.dataset.quickFiltersInitialized) return;
      root.dataset.quickFiltersInitialized = 'true';
      var entries = [];
      var navigation = document.createElement('div');
      navigation.className = 'cs-mobile-filter-nav';
      navigation.setAttribute('role', 'group');
      navigation.setAttribute('aria-label', 'Filter products');

      function setOpen(entry, open) {
        entry.header.classList.toggle('open', open);
        entry.panel.style.display = open ? 'block' : 'none';
        entry.button.setAttribute('aria-expanded', String(open));
      }

      function synchronize() {
        if (!mobile.matches) return;
        var block = root.querySelector('.sidebar-block');
        if (!block) return;
        var widgets = Array.from(block.children).filter(function (widget) {
          return widget.classList.contains('sidebar-tag') && widget.querySelector('.widget-header') && widget.querySelector('.widget-content');
        });
        // AJAX replaces sidebar-block. Rebuild only for new nodes, not our own
        // class changes, and never duplicate or clone the checkbox inputs.
        if (widgets.length !== entries.length || widgets.some(function (widget, index) { return entries[index].widget !== widget; })) {
          navigation.replaceChildren();
          entries = widgets.map(function (widget) {
            var header = widget.querySelector('.widget-header');
            var panel = widget.querySelector('.widget-content');
            var title = header.querySelector('.sidebar-title');
            var count = header.querySelector('.filter-count-css');
            var button = document.createElement('button');
            var id = 'cs-mobile-filter-' + (++nextPanelId);
            button.type = 'button';
            button.className = 'cs-mobile-filter-chip';
            // Respect the active language instead of concatenating both labels.
            var translated = title && title.querySelector(document.body.classList.contains('lang2') ? '.lang2' : '.lang1');
            button.textContent = (translated || title || header).textContent.trim() + (count ? ' ' + count.textContent.trim() : '');
            button.id = id + '-trigger';
            button.setAttribute('aria-controls', id);
            var entry = { widget: widget, header: header, panel: panel, button: button,
              display: panel.style.display, wasOpen: header.classList.contains('open') };
            panel.id = id;
            panel.setAttribute('aria-labelledby', button.id);
            setOpen(entry, false);
            button.addEventListener('click', function () {
              var shouldOpen = button.getAttribute('aria-expanded') !== 'true';
              entries.forEach(function (other) { setOpen(other, shouldOpen && other === entry); });
            });
            navigation.appendChild(button);
            return entry;
          });
          // The existing chip row places the first (Price) widget last.
          if (entries.length > 1) navigation.appendChild(entries[0].button);
          block.before(navigation);
        }
        entries.forEach(function (entry) {
          entry.button.setAttribute('aria-expanded', String(entry.panel.style.display !== 'none' && entry.header.classList.contains('open')));
        });
        root.classList.add('cs-mobile-filters-ready');
      }

      navigation.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') entries.forEach(function (entry) { setOpen(entry, false); });
      });
      mobile.addEventListener('change', function () {
        if (mobile.matches) {
          entries.forEach(function (entry) { setOpen(entry, false); });
          synchronize();
        } else {
          root.classList.remove('cs-mobile-filters-ready');
          entries.forEach(function (entry) {
            entry.panel.style.display = entry.display;
            entry.header.classList.toggle('open', entry.wasOpen);
          });
        }
      });
      new MutationObserver(synchronize).observe(root, { childList: true, subtree: true });
      synchronize();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeQuickFilters);
  else initializeQuickFilters();
})();

/* Collection palettes only: explicit selection mark and click-again removal. */
(function () {
  'use strict';
  function paletteSelection(link, current) {
    if (link.origin !== current.origin || link.pathname !== current.pathname) return false;
    var keys = ['constraint', 'filter.p.m.custom.color', 'filter.v.option.color'];
    return keys.every(function (key) {
      return !link.searchParams.has(key) || link.searchParams.get(key) === current.searchParams.get(key);
    });
  }
  function familyPaletteSelection(family, current) {
    // Only this family's original options count; a hover popover is not a selection.
    return Array.from(family.querySelectorAll('.color_box_new a[href]')).some(function (link) {
      try { return paletteSelection(new URL(link.getAttribute('href'), current), current); }
      catch (_) { return false; }
    });
  }
  function clearPaletteUrl(current, selectedLink) {
    var result = new URL(current.href);
    var categories = ['mother-of-the-bride-dresses', 'mother-of-the-bride', 'wedding-guest-dresses', 'bridesmaid-dresses', 'prom-dresses'];
    var handle = result.pathname.split('/collections/')[1];
    if (!handle) return null;
    var base = categories.find(function (category) {
      return handle === category || handle.endsWith('-' + category);
    });
    if (!base) return null;
    result.pathname = result.pathname.split('/collections/')[0] + '/collections/' + base;
    ['filter.p.m.custom.color', 'filter.v.option.color', 'page', 'variant'].forEach(function (key) { result.searchParams.delete(key); });
    if (selectedLink && selectedLink.searchParams.has('constraint')) result.searchParams.delete('constraint');
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { paletteSelection: paletteSelection, clearPaletteUrl: clearPaletteUrl, familyPaletteSelection: familyPaletteSelection };
  }
  if (typeof document === 'undefined') return;
  function addPaletteTick(visual, className) {
    if (visual.querySelector('.' + className)) return;
    var tick = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    tick.setAttribute('viewBox', '0 0 24 24');
    tick.setAttribute('aria-hidden', 'true');
    tick.setAttribute('class', className);
    tick.innerHTML = '<path d="M5 12l4 4L19 6" fill="none" stroke="#171717" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12l4 4L19 6" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>';
    visual.appendChild(tick);
  }
  function initializePalette() {
    if (!document.body.classList.contains('template-collection')) return;
    if (!document.getElementById('cs-collection-palette-state')) {
      var style = document.createElement('style');
      style.id = 'cs-collection-palette-state';
      style.textContent = '.template-collection .cs-collection-color-choice .color-swatches-icon{display:none!important}.template-collection .cs-collection-swatch-visual{position:relative;display:inline-block}.template-collection .cs-collection-color-tick,.template-collection .cs-collection-family-tick{display:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:22px;height:22px;z-index:2;pointer-events:none}.template-collection .cs-collection-color-selected .cs-collection-color-tick{display:block}.template-collection .cs-collection-family-selected>.color_family_inner_items .cs-collection-family-tick{display:block}.template-collection .cs-collection-family-tick{width:28px;height:28px}.template-collection .cs-collection-family-selected>.color_family_inner_items .color-swatches-icon{display:none!important}.template-collection .cs-collection-color-choice:focus-visible{outline:2px solid #7a3145;outline-offset:3px}';
      document.head.appendChild(style);
    }
    var current = new URL(window.location.href);
    document.querySelectorAll('color-family .color_box_new a[href]').forEach(function (link) {
      var url;
      try { url = new URL(link.getAttribute('href'), current); } catch (_) { return; }
      var selected = paletteSelection(url, current);
      link.classList.add('cs-collection-color-choice');
      link.classList.toggle('cs-collection-color-selected', selected);
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
      if (link.querySelector('.cs-collection-color-tick')) return;
      var visual = link.querySelector('.option_circle') || link.querySelector('picture') || link.querySelector('img');
      if (!visual) return;
      if (!visual.classList.contains('option_circle')) {
        var wrapper = document.createElement('span');
        wrapper.className = 'cs-collection-swatch-visual';
        visual.before(wrapper);
        wrapper.appendChild(visual);
        visual = wrapper;
      } else visual.classList.add('cs-collection-swatch-visual');
      addPaletteTick(visual, 'cs-collection-color-tick');
    });
    document.querySelectorAll('color-family .color_family_all').forEach(function (family) {
      var selected = familyPaletteSelection(family, current);
      family.classList.toggle('cs-collection-family-selected', selected);
      var visual = family.querySelector('.color_family_inner_items .colors_images_inner');
      if (!visual) return;
      visual.classList.add('cs-collection-swatch-visual');
      addPaletteTick(visual, 'cs-collection-family-tick');
    });
  }
  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('template-collection') || !event.target.closest ||
        event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('color-family .color_box_new a[href]');
    if (!link) return;
    var current = new URL(window.location.href);
    if (!paletteSelection(new URL(link.getAttribute('href'), current), current)) return;
    var reset = clearPaletteUrl(current, new URL(link.getAttribute('href'), current));
    if (!reset) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(reset.href);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePalette);
  else initializePalette();
  document.addEventListener('reload-collection', initializePalette);
  // Popovers clone the original options, including their checkmark and state.
})();

/* Close an open color-family popover without consuming the product-card click.
 * The transparent backdrop is click-through in collection-main.liquid. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var openFamilies = Array.from(document.querySelectorAll('color-family')).filter(function (family) {
      return family.querySelector('.content_color_all.appended');
    });
    if (!openFamilies.length) return;
    if (event.target.closest('color-family .color_family_all, color-family .mega_color_group')) return;
    openFamilies.forEach(function (family) {
      if (typeof family.r === 'function') family.r();
    });
  });
})();
